/**
 * @typedef {Object} NavLeaf
 * @property {string} label
 * @property {string} [key]
 * @property {string} [route]
 * @property {string[]} [permission]
 * @property {string} [accessKey]
 * @property {import('../../authorization/types/authz.types').AuthzRequirement} [access]
 * @property {number|string} [badge]
 * @property {NavLeaf[]} [children]
 */

/**
 * @typedef {Object} NavItem
 * @property {string} [title]
 * @property {string} [label]
 * @property {string} [key]
 * @property {string} [iconKey]
 * @property {string} [route]
 * @property {string[]} [permission]
 * @property {string} [accessKey]
 * @property {import('../../authorization/types/authz.types').AuthzRequirement} [access]
 * @property {number|string} [badge]
 * @property {NavLeaf[]} [children]
 */

/**
 * @typedef {Object} NavSection
 * @property {string|null} [title] - Null/empty = pin items above labeled sections (no heading)
 * @property {NavItem[]} items
 */

export const CONCEPT_BUILDER_KEY = 'conceptBuilder';
export const PRACTICE_TEST_KEY = 'practiceTest';

export const BUSINESS_FUNCTIONS_SECTION = 'Business Functions';

export const SIDEBAR_STORAGE_KEY = 'machadalo-sidebar-collapsed';
